import RequestAbstract from "../abstract";

export default class PublicAppealComments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-appeal-comments';
    }
}
